"use client";

import * as React from 'react'; // TODO: check

var context = /*#__PURE__*/React.createContext(null);
context.displayName = 'NavbarContext';
export default context;